// Libraries
import React from "react";
import { EditableInput, useObserver, useState } from "@shoothill/core";
import * as Mui from "@material-ui/core";

// Custom

// Components

// Styling & images
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { Box, Button, Modal } from "@material-ui/core";
import styled from "styled-components";
import { CrossSVG } from "Globals/Views/IconSVGs/CrossSVG";
// TODO Move styles to separate file
// TODO implement theme colors instead of hardcoded hex values
export const ModalBase: any = styled(Modal)`
    padding: 0px;
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    max-width: 375px;

    .modalhead,
    .modalbody {
        padding: 10px 15px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }

    .modalhead {
        border-radius: 5px 5px 0px 0px;
        background-color: #84bb25;
        color: white;

        h2 {
            margin: 0 auto;
            font-size: 1.8em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }
    .modalbody {
        border-radius: 0px 0px 5px 5px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        padding-left: 1em;
        text-indent: -0.7em;
        font-size: 12px;
    }

    li::before {
        content: "•";
        padding-right: 7px;
        color: #19bb00;
    }
`;
export const ModelButtonsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    button {
        border-radius: 0px;
        display: flex;
        flex: 1 50%;
        color: white;
        font-size: 12px;
        background-color: #3c3c3b;
    }
    button:first-child {
        background-color: #19bb00;
    }
`;

interface IProps {
    isActive: boolean;
    confirmClose(confirm: boolean): void;
    onCancel(): void;
}

export const ApproveApplicationModal: React.FC<IProps> = (props) => {
    return useObserver(() => (
        <>
            <ModalBase open={props.isActive} onClose={() => props.onCancel()}>
                <div>
                    <Box className="modalhead" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Mui.Typography variant="h6">Approve application </Mui.Typography>
                        <div style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => props.onCancel()}>
                            <CrossSVG />
                        </div>
                    </Box>
                    <div className="modalbody">
                        <p style={{ fontSize: "12px", fontWeight: "bold" }}>Are you sure you wish to approve this application?</p>
                        <ModelButtonsContainer>
                            <Mui.Button
                                id="save"
                                variant="contained"
                                onClick={() => {
                                    props.confirmClose(true);
                                }}
                            >
                                Approve application
                            </Mui.Button>
                            <span style={{ paddingRight: "30px" }} />
                            <Mui.Button
                                id="cancel"
                                variant="contained"
                                onClick={() => {
                                    props.onCancel();
                                }}
                            >
                                Cancel
                            </Mui.Button>
                        </ModelButtonsContainer>
                    </div>
                </div>
            </ModalBase>
        </>
    ));
};
